(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-msi-label"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:changed', function(event) {
    var variant = event.detail && event.detail.variant;
    var section = event.target;

    if (!section || typeof section.querySelectorAll !== 'function') return;

    section.querySelectorAll('[data-msi-variant-label]').forEach(function(label) {
      label.hidden = !variant || variant.price < Number(label.dataset.msiThreshold);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
